import { useEffect, useState } from "react";
import { DownloadSimple, X } from "@phosphor-icons/react";

export default function PWAInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => {
      e.preventDefault();
      if (sessionStorage.getItem("viva_pwa_dismissed")) return;
      setDeferred(e);
      setVisible(true);
    };
    const onInstalled = () => setVisible(false);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!visible) return null;

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch (e) { /* ignore */ }
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    sessionStorage.setItem("viva_pwa_dismissed", "1");
    setVisible(false);
  };

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 sm:w-80 z-[60] bg-[#09090B] text-white border border-zinc-700 shadow-2xl p-4 flex items-center gap-3"
    >
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold uppercase tracking-wide">Install VIVA App</p>
        <p className="text-xs text-zinc-400 mt-0.5">Add to your home screen for one-tap access.</p>
      </div>
      <button
        onClick={install}
        data-testid="pwa-install-button"
        className="shrink-0 bg-primary hover:bg-[#C2410C] text-white text-xs font-bold uppercase tracking-wide px-3 py-2 flex items-center gap-1 transition-colors duration-100"
      >
        <DownloadSimple size={14} weight="bold" /> Install
      </button>
      <button onClick={dismiss} data-testid="pwa-install-dismiss" aria-label="Dismiss" className="shrink-0 text-zinc-500 hover:text-white p-1">
        <X size={16} weight="bold" />
      </button>
    </div>
  );
}
